import { Box, Button, FileInput, Image, LoadingOverlay, Paper, SimpleGrid, Space, Text, Textarea, TextInput, Title } from '@mantine/core';
import React, { memo, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { notifications } from '@mantine/notifications';
import useFetch from '../../../../Customhooks/useFetch';
import ProductCharacteristics from './ProductCharacteristics/ProductCharacteristics.component';
import { baseUrl } from '../../../../Constants/constant';
import classes from '../ManageProduct.module.css';

interface FormField {
    id_comp: number;
    // country: string | null;
    id: number | null;
    vertical_id: string | null;
    category_id: string | null;
    material_name: string | null;
    materialSub_type_name: string | null;
    water_consumption: string;
    weight: string;
    percentage: string;
    gsm_size: string;
    sheet_size_height: string;
    sheet_size_width: string;
    no_of_product: string;
    // no_of_layers: string;
    // glue_Co2: string;
    // coverage: string;
    // ink_co2: string;
    weight_type: string,
}

interface ProductForm {
    name: string;
    product_description: string,
    product_image: File | null,
    product_components: Array<{
        // country_id: string | null;
        id: number | null;
        vertical_id: string | null;
        category_id: string | null;
        raw_material_id: string | null;
        raw_material_sub_id: string | null;
        water_consumtion: string;
        weight: string;
        percentage: string;
        gsm_size: string;
        sheet_size_height: string;
        sheet_size_width: string;
        no_of_product: string;
        // no_of_layers: string;
        // glue_Co2: string;
        // coverage: string;
        // ink_co2: string;
    }>;
};
const jsonToFormData = (obj: any) => {
    const formData = new FormData();

    Object.keys(obj).forEach(key => {
        if (obj[key] instanceof File) {
            formData.append(key, obj[key]);
        } else if (Array.isArray(obj[key]) || typeof obj[key] === 'object') {
            formData.append(key, JSON.stringify(obj[key]));
        } else {
            formData.append(key, obj[key]);
        }
    });

    return formData;
};

const AddProducts = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const token = localStorage.getItem("token") || "";
    const updatedUrl = baseUrl.replace("/api/", "");

    const [productName, setProductName] = useState('');
    const [fileItem, setFileItem] = useState<File | null>(null);
    const [productDataID, setproductDataID] = useState<any>();
    const [productDescription, setProductDescription] = useState('');
    const [formData, setFormData] = useState<FormField[]>([]);
    const [isValid, setIsValid] = useState(false);
    const [errors, setErrors] = useState<{ product_name?: string, product_description?: string, product_icon?: string }>({});
    const [requestData, setRequestData] = useState<ProductForm | null>(null);
    const [showErrors, setShowErrors] = useState(false);
    const [preview, setPreview] = useState<string | null>(null);
    const [imageUrl, setImageUrl] = useState<string>('');
    const [initialProductCharacteristics, setInitialProductCharacteristics] = useState<FormField[]>([]);

    // Fetch product data hook
    const {
        data: getDataproductid,
        loading: productIdLoading,
        error,
        fetchData: fetchProductDetails
    } = useFetch({
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
            "token": token,
        },
    });

    // Save/Update product hook
    const {
        data: productData,
        error: productError,
        loading: productLoading,
        fetchData: postProduct
    } = useFetch({
        method: id ? 'PUT' : 'POST',
        headers: {
            // "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            token: token,
        },
        body: requestData ? requestData : undefined
    });

    // Fetch product data if editing
    useEffect(() => {
        if (!id) return;
        fetchProductDetails(`${baseUrl}admin/products/${id}`);
    }, [id]);
    useEffect(() => {
        if (!getDataproductid) return;
        if (getDataproductid?.data) {
            setproductDataID(getDataproductid?.data);
            setProductName(getDataproductid?.data?.rows[0]?.name);
            setProductDescription(getDataproductid?.data?.rows[0]?.product_description);
            setImageUrl(getDataproductid?.data?.rows[0]?.product_image)

            if (getDataproductid.data?.rows[0]?.ProductComponents) {
                const transformedFields = getDataproductid?.data?.rows[0]?.ProductComponents.map((char: any, index: number) => ({
                    id_comp: index + 1,
                    // country: char.country_id,
                    ...(char?.id ? { id: char?.id } : {}),
                    vertical_id: char?.vertical_id,
                    category_id: char?.category_id,
                    material_name: char?.raw_material_id,
                    materialSub_type_name: char?.raw_material_sub_id,
                    water_consumption: char?.water_consumtion,
                    weight: char?.weight,
                    percentage: char?.percentage,
                    gsm_size: char?.gsm_size,
                    sheet_size_height: char?.sheet_size_height,
                    sheet_size_width: char?.sheet_size_width,
                    no_of_product: char?.no_of_product,
                    // no_of_layers: char?.no_of_layer,
                    // glue_Co2: char?.glue_type_co2,
                    // coverage: char?.coverage,
                    // ink_co2: char?.ink_type_co2,
                    weight_type: char?.RawMaterialSubType?.Weighttype?.weight_name
                }));

                setInitialProductCharacteristics(transformedFields);
                setFormData(transformedFields);
            }
        }
    }, [getDataproductid]);

    const showNotification = (type: 'success' | 'error', message: string) => {
        notifications.show({
            title: type === 'success' ? 'Success' : 'Error',
            message,
            color: type === 'success' ? 'green' : 'red',
            classNames: classes,
        });
    };

    const handleFieldsChange = (fields: FormField[]) => {
        setFormData(fields);
    };

    const handleValidationChange = (valid: boolean) => {
        setIsValid(valid);
    };

    const validateForm = (): boolean => {
        const newErrors: { product_name?: string, product_description?: string, product_icon?: string } = {};

        if (!productName.trim()) {
            newErrors.product_name = 'Product name is required';
        }
        if (!productDescription.trim()) {
            newErrors.product_description = 'Product Description is required';
        }
        if (!id) {
            if (!fileItem) {
                newErrors.product_icon = 'Product Image is required';
            }
            else if (!(fileItem instanceof File)) {
                newErrors.product_icon = "Invalid file format";
            }
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return false;
        }
        return true;
    };

    const handleChange = (field: string, value: string | null) => {
        // if (field === "material_name") {
        //     setMaterialname(value as string);
        // } else
        if (field === "product_name") {
            setProductName(value as string);
        }
        else if (field === "product_description") {
            setProductDescription(value as string);
        }

        // Remove the error for the field if it's being updated
        setErrors((prev: any) => ({ ...prev, [field]: undefined }));
    };

    const handleSave = async () => {
        setShowErrors(true); // Show errors when save is clicked

        if (!validateForm()) {
            showNotification('error', 'Please fill all required fields');
            return;
        }
        if (!isValid) {
            showNotification('error', 'Please fill all required fields');
            return;
        }

        const data: ProductForm = {
            name: productName,
            product_description: productDescription,
            product_image: fileItem,
            product_components: formData.map(field => {
                const componentData: any = {
                    vertical_id: field.vertical_id,
                    category_id: field.category_id,
                    raw_material_id: field.material_name,
                    raw_material_sub_id: field.materialSub_type_name,
                    water_consumtion: field.water_consumption,
                };

                if (field?.id) {
                    componentData.id = field?.id;
                }
                if (field?.weight) {
                    componentData.weight = field?.weight;
                }
                if (field?.percentage) {
                    componentData.percentage = field?.percentage;
                }
                if (field?.gsm_size) {
                    componentData.gsm_size = field?.gsm_size;
                }
                if (field?.sheet_size_height) {
                    componentData.sheet_size_height = field?.sheet_size_height;
                }
                if (field?.sheet_size_width) {
                    componentData.sheet_size_width = field?.sheet_size_width;
                }
                if (field?.no_of_product) {
                    componentData.no_of_product = field?.no_of_product;
                }
                // if (field?.no_of_layers) {
                //     componentData.no_of_layer = field?.no_of_layers;
                // }
                // if (field?.glue_Co2) {
                //     componentData.glue_type_co2 = field?.glue_Co2;
                // }
                // if (field?.coverage) {
                //     componentData.coverage = field?.coverage;
                // }
                // if (field?.ink_co2) {
                //     componentData.ink_type_co2 = field?.ink_co2;
                // }

                return componentData;
            })
        };
        const ProductData: any = jsonToFormData(data);
        setRequestData(ProductData);
    };

    useEffect(() => {
        const makeApiCall = async () => {
            if (requestData) {
                const url = id ? `${baseUrl}admin/products/update/${id}` : `${baseUrl}admin/products/add`;
                await postProduct(url);
            }
        };

        makeApiCall();
    }, [requestData]);
    useEffect(() => {
        if (fileItem) {
            const objectUrl = URL.createObjectURL(fileItem);
            setPreview(objectUrl);
            return () => URL.revokeObjectURL(objectUrl); // Cleanup
        }
    }, [fileItem]);

    useEffect(() => {
        if (productError || (productData && productData.errors)) {
            showNotification('error', productData?.message || productError?.message || 'Something went wrong');
            return;
        }

        if (productData && !productData.errors) {
            showNotification('success', 'Product saved successfully');
            navigate('/manage-products');
        }
    }, [productData, productError]);

    return (<>
        <LoadingOverlay
            visible={productIdLoading}
            zIndex={1000}
            overlayProps={{
                radius: 'sm',
                blur: 2,
                style: {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%'
                }
            }}
            loaderProps={{ color: '#404040', type: 'bars' }}
        />
        <Paper shadow="xs" p="xs" radius="md">
            <Box ml={5}>
                <Title order={4}>{id ? 'Edit Product' : 'Add Product'}</Title>
                <Space h="lg" />
                <Text>Product Details</Text>
                <Space h="xs" />
                <SimpleGrid cols={4}>
                    <TextInput
                        value={productName}
                        onChange={(e) => handleChange("product_name", e.target.value)}
                        label="Product Name"
                        variant="filled"
                        withAsterisk
                        placeholder="Enter product name"
                        radius={6}
                        error={errors.product_name}
                    />
                    <FileInput
                        label="Upload icon"
                        withAsterisk={id ? false : true}
                        variant="filled"
                        placeholder="Upload icon"
                        value={fileItem}
                        onChange={setFileItem}
                        radius={6}
                        error={errors.product_icon}
                    />
                    {preview ? (
                        <Box className={classes.verticalslogo}>
                            <Image fit="contain" src={preview} alt="icon" />
                        </Box>
                    ) : (id && updatedUrl && imageUrl && (<Box className={classes.verticalslogo}>
                        <Image fit="contain" src={`${updatedUrl}${imageUrl}`} alt="icon" />
                    </Box>))}
                </SimpleGrid>
                <Textarea
                    label="Product Description"
                    placeholder="Enter your Product Description"
                    withAsterisk
                    variant="filled"
                    autosize
                    value={productDescription}
                    onChange={(e) => handleChange("product_description", e.target.value)}
                    minRows={3}
                    maxRows={4}
                    radius={6}
                    error={errors.product_description}
                />
                <Space h="lg" />
                <ProductCharacteristics
                    onFieldsChange={handleFieldsChange}
                    onValidationChange={handleValidationChange}
                    showErrors={showErrors}
                    initialFields={initialProductCharacteristics}

                />
                <Space h="sm" />
                <SimpleGrid cols={6}>
                    <Button
                        variant="default"
                        radius={6}
                        onClick={() => navigate('/manage-products')}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="gradient"
                        gradient={{ from: '#404040', to: '#404040', deg: 90 }}
                        radius={6}
                        onClick={handleSave}
                        loading={productLoading}
                        disabled={productLoading}
                    >
                        {id ? 'Update' : 'Save'}
                    </Button>
                </SimpleGrid>
            </Box>
        </Paper>
    </>
    );
};

export default memo(AddProducts);